import React from "react";
import styled from "styled-components";
import I10n from "../../features/i10n";
import MsxIcons from "../../features/msx-icons";
import LicenseSelectorPackageSummaryContent from "./license_selector_package_summary_content";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 0px;
  max-height: 100%;
  border-radius: 8px;
  background-color: white;
  ${props => props.$isOpen ? '' : 'align-self: flex-start;'}
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-bottom: 1px solid #d9d9d9;
  ${props => props.$nbLicensesAdded > 0 && !props.$canClose ? 'cursor: pointer;' : ''}
`;

const TitleRow = styled.div`
  display: flex;
  justify-content: space-between;
`;

const IconWrapper = styled.div`
  transition: transform 0.3s;
  transform: ${(props) => (props.isOpen ? "rotate(180deg)" : "rotate(0deg)")};
  margin-left: 10px;
  align-self: flex-start;
  cursor: pointer;
`;

const PackageSummaryTitle = styled.span`
  font-size: 24px;
  font-weight: 400;
`;

const PackageSummarySubtitle = styled.span`
  font-size: 18px;
  font-weight: 400;
  color: #000000;
  margin-top: 20px;
`;

const Tag = styled.div`
  display: inline-flex;
  background-color: #CCF1FF;
  color: #005B80;
  font-weight: 400;
  font-size: 14px;
  border-radius: 9999px;
  padding: 5px 10px;
`;


class LicenseSelectorPackageSummary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: true,
    };
  }

  render() {
    const nbLicensesAdded = this.props.licenseGroups.flatMap(licenseGroup => {
      return licenseGroup.licences.map(license => license);
    })
    .filter(licence => licence.ignoreGlobalQuantity == null || licence.ignoreGlobalQuantity === false)
    .reduce((accumulator, license) => {
      return accumulator + license.quantity;
    }, 0);

    return (
      <Container $isOpen={this.state.isOpen && nbLicensesAdded > 0}>
        <Header
          $nbLicensesAdded={nbLicensesAdded}
          $canClose={this.props.onClose != null}
          onClick={() => {
            if (nbLicensesAdded > 0 && this.props.onClose == null) {
              this.setState({ isOpen: !this.state.isOpen });
            }
          }}
          >
          <TitleRow>
            <PackageSummaryTitle>
              {I10n.get("screen.licence_selector.package_summary")}
            </PackageSummaryTitle>
            {nbLicensesAdded > 0 && <IconWrapper
              isOpen={this.state.isOpen}
            >
              {this.props.onClose ? <MsxIcons name="close" onClick={(event) => {
                event.stopPropagation();
                this.props.onClose();}}></MsxIcons> : <MsxIcons name="down-arrow"></MsxIcons>}
            </IconWrapper>}
          </TitleRow>
          {nbLicensesAdded > 0 && <PackageSummarySubtitle>{I10n.getAndReplace('screen.licence_selector.nb_items_added_to_package', nbLicensesAdded)} {this.props.availableLicenseModels?.length > 1 && <Tag>{I10n.getOrDefault(`screen.licence_selector.license_model.${this.props.licenseModel}`, this.props.licenseModel)}</Tag>}</PackageSummarySubtitle>}
        </Header>
        {nbLicensesAdded > 0 && <LicenseSelectorPackageSummaryContent
          licenseGroups={this.props.licenseGroups}
          isOpen={this.state.isOpen}
          canOptimize={this.props.canOptimize}
          optimizationHintLabel={this.props.optimizationHintLabel}
          optimizeLicenses={this.props.optimizeLicenses}
          disabled={this.props.disabled}
          onOptimizeChange={this.props.onOptimizeChange}
          removeSoftwareLicence={this.props.removeSoftwareLicence}
          actionButtons={this.props.actionButtons}
          onClear={this.props.onClear}
        >
        </LicenseSelectorPackageSummaryContent>}
      </Container>
    );
  }
}

export default LicenseSelectorPackageSummary;
